export const PEOPLE_TITLE = "People";
export const PEOPLE_SUBTITLE = "View users within your organisation."; // will be updated in OOP2
export const PEOPLE_TABLE_NAME_HEADER = "Name";
export const PEOPLE_TABLE_ROLE_HEADER = "Role";
export const PEOPLE_TABLE_LAST_LOGIN_HEADER = "Last Login";
export const PEOPLE_TABLE_NO_RESULTS_TITLE = "No results";
export const PEOPLE_TABLE_NO_RESULTS_EMPTY_ORG = "No users found.";
export const PEOPLE_TABLE_NO_RESULTS_SEARCH =
  "Please update your search criteria.";

export const PEOPLE_SEARCH_USERS_PLACEHOLDER = "Search by name or email...";

export const CANCEL = "Cancel";
export const SAVE = "Save";
export const EDIT_ROLE = "Edit role";
